import { useState, type MouseEvent } from 'react';
import {
	Box,
	Chip,
	Collapse,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Status, PaymentStatus } from '../../../components/request';
// import { useTheme } from '@mui/material/styles';

// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { type BulkRequestProps, BulkRequest } from '../../../models';
import { fDateTime } from '../../../utils/formatTime';
import Iconify from '../../../components/iconify';

interface BulkRequestTableRowProps {
	bulkRequest: BulkRequestProps;
	handleOpenMenu: (event: MouseEvent<HTMLElement>) => void;
	handleOpenStatusEditingDialog: (event: MouseEvent<HTMLElement>) => void;
	handleOpenAssessmentDateDialog: (event: MouseEvent<HTMLElement>) => void;
}

export const BulkRequestTableRow = (props: BulkRequestTableRowProps) => {
	const { bulkRequest, handleOpenMenu, handleOpenAssessmentDateDialog, handleOpenStatusEditingDialog } = props;
	const [open /*setOpen*/] = useState(false);
	const theme = useTheme();

	const tests = bulkRequest.tests ?? [];
	const user = bulkRequest.user;
	const assessmentDates = bulkRequest.assessmentDates;

	return (
		<>
			<TableRow
				hover
				tabIndex={-1}
				// selected={selected.indexOf(candidateName) !== -1}
				// sx={isArchived ? { backgroundColor: theme.palette.grey['400'] } : {}}
			>
				{/*				<TableCell>
					<IconButton size="small" onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCell>*/}
				<TableCell align="left">
					<Typography variant="subtitle2">{bulkRequest.id}</Typography>
				</TableCell>
				<TableCell align="left">
					<Typography variant="subtitle2">{user?.company}</Typography>
				</TableCell>
				<TableCell align="left">
					<Typography variant="subtitle2">
						{user?.firstname} {user?.lastname}
					</Typography>
				</TableCell>
				<TableCell align="left">{bulkRequest.location}</TableCell>
				<TableCell
					align="left"
					sx={{
						':hover': {
							cursor: 'pointer',
							color: theme.palette.primary.main,
						},
					}}
				>
					{BulkRequest.isAssessmentDatesSet(assessmentDates) ? (
						<Box sx={{ width: 150 }}>
							<Chip
								sx={{
									height: 'auto',
									'& .MuiChip-label': {
										display: 'block',
										whiteSpace: 'pre-line',
									},
								}}
								label={assessmentDates?.map((date, i) => fDateTime(date)).join('\n')}
								color="primary"
								variant="outlined"
								data-request-id={bulkRequest.id}
								onClick={handleOpenAssessmentDateDialog}
							/>
						</Box>
					) : (
						<Chip
							label={'Select a Date'}
							color="primary"
							variant="outlined"
							data-request-id={bulkRequest.id}
							onClick={handleOpenAssessmentDateDialog}
						/>
					)}
				</TableCell>

				<TableCell align="left">
					<PaymentStatus paymentStatus={bulkRequest.paymentStatus || 'Unknown'} />
				</TableCell>
				<TableCell align="left">
					<Status
						status={bulkRequest.status || ''}
						clickable
						correlationId={bulkRequest.id}
						onClick={handleOpenStatusEditingDialog}
					/>
				</TableCell>

				<TableCell>
					<IconButton size="large" color="inherit" data-request-id={bulkRequest.id} onClick={handleOpenMenu}>
						<Iconify icon={'eva:more-vertical-fill'} />
					</IconButton>
				</TableCell>
			</TableRow>

			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<Typography variant="h6" gutterBottom component="div">
								History
							</Typography>
							<Table size="small" aria-label="purchases">
								<TableHead>
									<TableRow>
										<TableCell>Date</TableCell>
										<TableCell>Customer</TableCell>
										<TableCell align="right">Amount</TableCell>
										<TableCell align="right">Total price ($)</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{tests.map((test, i) => (
										<TableRow key={test.name}>
											<TableCell component="th" scope="row">
												{test.name}
											</TableCell>
											<TableCell>{test.price}</TableCell>
											<TableCell align="right">{test.quantity}</TableCell>
											<TableCell align="right">111</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};
